/** The whole DID, shortened to the column by CSS; the title carries it all. */
export function Did({ value }: { value: string }) {
  return (
    <span className="did" title={value}>
      {value}
    </span>
  );
}
